/**
 * Uslugi merchanta ktore zostaly z sukcesem uruchomione
 */
export const P24MerchantServices = {

    _UNDEFINED: {
        id: 0,
        name: '_UNDEFINED',
        displayText: 'Brak'
    },
    _TRN_REGISTER: {
        id: 1,
        name: '_TRN_REGISTER',
        displayText: 'Rejestracja płatności'
    },
    _TRN_NOTIFICATION: {
        id: 2,
        name: '_TRN_NOTIFICATION',
        displayText: 'Notyfikacja płatności'
    },
    _PAYMENT_METHOD_BLIK_CHARGE_BY_CODE: {
        id: 4,
        name: '_PAYMENT_METHOD_BLIK_CHARGE_BY_CODE',
        displayText: 'Płatność BLIK'
    },
    _TRN_BLIK_NOTIFICATION: {
        id: 8,
        name: '_TRN_BLIK_NOTIFICATION',
        displayText: 'Notyfikacja płatności BLIK'
    },
    _TRN_VERIFY: {
        id: 16,
        name: '_TRN_VERIFY',
        displayText: 'Weryfikacja płatności'
    },
    _TRN_REFUND: {
        id: 32,
        name: '_TRN_REFUND',
        displayText: 'Zwrot płatności'
    },
    _TRN_REFUND_NOTIFICATION: {
        id: 64,
        name: '_TRN_REFUND_NOTIFICATION',
        displayText: 'Notyfikacja zwrotu płatności'
    }

}

/**
 * Kolekcja typow
 */
export const P24MerchantServicesList = Object.keys(P24MerchantServices).map(type => P24MerchantServices[type]).filter(type => type.name !== P24MerchantServices._UNDEFINED.name)

/**
 * Metoda zwracająca typ bazując na identyfikatorze
 * 
 * @param {int} id identyfikator typu 
 * 
 * @returns {P24MerchantServices} typ 
 */
export const getP24MerchantServicesById = (id) => {
    if (!id) {
        return P24MerchantServices._UNDEFINED;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let type = P24MerchantServicesList.find(item => item.id === id)
    return type;
}

/**
 * Metoda zwracająca typ  bazując na nazwie
 * 
 * @param {String} name nazwa typu 
 * 
 * @returns {P24MerchantServices} typ 
 */
export const getP24MerchantServicesByName = (name) => {
    if (!name) {
        return P24MerchantServices._UNDEFINED;
    }

    // szukamy pierwszego elementu, który spełnia warunki dla podanych parametrów wejściowych  
    let type = P24MerchantServicesList.find(item => item.name === name)
    return type;
}

/**
 * Sprawdza czy w podanej wartosci - result - reprezentacji bitowej, znajduje sie podana usluga
 * 
 * @param {P24MerchantServices} service usluga do sprawdzenia
 * @param {int} result wartosc bitowa uruchomionych uslug
 */
export const checkP24MerchantService = (service, result) => {

    if (result === 0) {
        return false;
    }

    return (result & service.id) === service.id;

}

/**
 * Sprawdza czy w podanej wartosci - result - reprezentacji bitowej - jest max mozliwa wartosc
 * 
 * @param {int} result wartosc bitowa uruchomionych uslug, do sprawdzenia
 */
export const checkAllP24MerchantServices = (result) => {

    if (result === 0) {
        return false;
    }

    //tworzymy nowa tablice, z samymi id
    let bitArray = P24MerchantServicesList.map(item => item.id);

    //liczymy sume bitow z powyzszej tablicy
    let bitSum = bitArray.reduce((previousValue, currentValue, index, array) => (previousValue + currentValue));

    //sprawdzaczy czy suma maksymalna to nasza wartosc
    return bitSum === result;

}